import { jwtDecode, JwtPayload } from 'jwt-decode';

declare const abp: any;

/** The current token's payload, or undefined when there is none or it cannot be read. */
const decodeToken = (): JwtPayload | undefined => {
  const token = abp.auth.getToken();

  if (!token) return undefined;

  try {
    return jwtDecode(token);
  } catch {
    return undefined; // an unreadable token is no better than a missing one
  }
};

// Function to check if the token has expired
export const isTokenExpired = () => {
  const decoded = decodeToken();

  if (!decoded) return true; // Token is missing or invalid

  return decoded.exp !== undefined && decoded.exp * 1000 < Date.now();
};

/**
 * Milliseconds until the token's `exp`, negative once it has passed. Undefined means there is
 * no clock to watch - no token, or one without an expiry - which is a different thing from a
 * session that has run out, and callers treat it as such.
 */
export const millisecondsUntilExpiry = (): number | undefined => {
  const exp = decodeToken()?.exp;

  return exp === undefined ? undefined : exp * 1000 - Date.now();
};

/**
 * Whether the browser is holding a token at all, sound or not. The cookie carrying it expires
 * on its own, so a session that runs out leaves nothing behind - and that is a different
 * situation from a visitor who was never signed in.
 */
export const hasToken = (): boolean => !!abp.auth.getToken();
